export const T = {
  en_GB: { clear: "Clear" },
  nb_NO: { clear: "Tøm" },
} as const;
